import { createContext, useContext } from 'react';
import type { AltDealStructureGridCell } from '@makemydeal/dr-platform-types';

export interface GridSelectionState {
    finance: AltDealStructureGridCell | null;
    lease: AltDealStructureGridCell | null;
}

export interface GridActionsValue {
    retry: (batchKey: string) => void;
    setTerms: (terms: number[]) => void;
    setDownPayments: (downPayments: number[]) => void;
    onCellSelect: (cell: AltDealStructureGridCell) => void;
    selectedCells: GridSelectionState;
    isCellDisabled: (cell: AltDealStructureGridCell) => boolean;
    canCreateScenarios: boolean;
    handleCreateScenarios: () => void;
    isAtMaxScenarios: boolean;
    resetSelection: () => void;
    /** Record a down-payment value the user explicitly entered (keyed `${dealType}-${value}`). Lets
     *  the retry banner tell an invalid down payment (don't retry) from a transient row failure (retry). */
    markEditedDownPayment: (dealType: 'finance' | 'lease', value: number) => void;
    /** Keys (`${dealType}-${value}`) of down-payment values the user has entered this session. */
    editedDownPaymentKeys: Set<string>;
}

export const ActionsContext = createContext<GridActionsValue | undefined>(undefined);

export const useGridActions = (): GridActionsValue => {
    const value = useContext(ActionsContext);
    if (!value) {
        throw new Error('useGridActions must be used within an AltDealStructureDataProvider');
    }
    return value;
};
